import React, { useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { CATEGORIES } from '../data/shayari';
import { useApp } from '../context/AppContext';

const CategoryStrip = () => {
  const { categoryId } = useParams();
  const { language } = useApp();

  const allLabel = language === 'hi' ? 'सभी' : language === 'ur' ? 'سب' : language === 'es' ? 'Todo' : language === 'fr' ? 'Tous' : 'All';
  const ALL_CATS = [{ id: '', label: allLabel, icon: '🌟' }, ...CATEGORIES];
  const DOUBLED  = [...ALL_CATS, ...ALL_CATS];
  const trackRef = useRef(null);

  const pause  = () => { if (trackRef.current) trackRef.current.style.animationPlayState = 'paused'; };
  const resume = () => { if (trackRef.current) trackRef.current.style.animationPlayState = 'running'; };

  return (
    <section className="cat-strip">
      <div
        className="cat-strip__marquee-outer"
        onMouseEnter={pause}
        onMouseLeave={resume}
      >
        <div className="cat-strip__marquee-track" ref={trackRef}>
          {DOUBLED.map((cat, i) => (
            <Link
              key={`${cat.id}-${i}`}
              to={cat.id ? `/category/${cat.id}` : '/'}
              className={`cat-chip ${categoryId === cat.id && cat.id !== '' ? 'cat-chip--active' : !categoryId && cat.id === '' ? 'cat-chip--active' : ''}`}
              style={cat.color ? { '--chip-color': cat.color, '--chip-gradient': cat.gradient } : {}}
            >
              <span>{cat.icon}</span>
              <span>{cat.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryStrip;
